import { CreateResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';

import type {
  ServiceTitanPortalPhoneCallCreateDTO,
  PhoneCallDetailDTO,
  ServiceTitanPortalReviewCallDTO
} from '../apiTypes.shim';

interface ServiceTitanPortalV2PhoneCallResource
  extends CreateResource<ServiceTitanPortalPhoneCallCreateDTO, PhoneCallDetailDTO> {
  reviewCall: (data: ServiceTitanPortalPhoneCallCreateDTO) => Promise<ServiceTitanPortalReviewCallDTO>;
}

export const createServiceTitanPortalV2PhoneCallResource = (): ServiceTitanPortalV2PhoneCallResource => {
  const phoneCallUri = `v2/phone-calls/st-portal`;
  const { create, useCreate } = createApiResource(API, phoneCallUri);
  const { create: reviewCall } = createApiResource(API, `${phoneCallUri}/review`);

  return { create, useCreate, reviewCall };
};
